import { useEffect, useState } from "react";
import client from "@/lib/api";
import { MapPin, Link2, X } from "lucide-react";

// Intake hint: open calls within 500 ft of the verified pin, with one-tap ATTACH.
export const NearbyOpenCalls = ({ geo, onAttach, attaching = false }) => {
  const [rows, setRows] = useState([]);
  const [hidden, setHidden] = useState(false);
  useEffect(() => {
    setHidden(false);
    if (!geo?.lat || !geo?.lng) { setRows([]); return; }
    client.get("/ali/nearby-open", { params: { lat: geo.lat, lng: geo.lng, radius_ft: 500 } })
      .then((r) => setRows(r.data.nearby || [])).catch(() => setRows([]));
  }, [geo?.lat, geo?.lng]);
  if (hidden || !rows.length) return null;
  return (
    <div data-testid="nearby-open-calls" className="mt-2 border border-[#F59E0B] bg-[#F59E0B]/10 px-3 py-2">
      <div className="flex items-center gap-1.5 font-mono text-[10px] font-bold uppercase text-[#FCD34D]">
        <MapPin size={12} /> {rows.length} open call{rows.length > 1 ? "s" : ""} within 500 ft — same incident?
        <button type="button" onClick={() => setHidden(true)} className="ml-auto text-[#9CA3AF] hover:text-white"><X size={12} /></button>
      </div>
      <div className="mt-1.5 space-y-1">
        {rows.map((r) => (
          <div key={r.id} data-testid={`nearby-open-${r.cc_number}`} className="flex items-center gap-2 font-mono text-[10px] text-[#E5E7EB]">
            <span className="text-white font-bold">{r.cad_number || r.cc_number}</span>
            <span className="truncate flex-1">{r.call_type || r.status} · {r.address} · <span className="text-[#FCD34D]">{r.distance_ft} ft</span>{r.callers > 1 ? ` · ${r.callers} callers` : ""}</span>
            <button type="button" data-testid={`nearby-attach-${r.cc_number}`} onClick={() => onAttach(r)} disabled={attaching}
              className="flex items-center gap-1 px-2 py-0.5 font-head font-bold text-[10px] bg-[#EF4444] text-white hover:bg-[#dc2626] disabled:opacity-50"><Link2 size={10} /> ATTACH CALLER</button>
          </div>
        ))}
      </div>
    </div>
  );
};
